@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.helperWrapper {
  margin-bottom:  hevo-toolkit-variables.$spacer * 2;
  .helper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: start;
    .helperText {
      display: flex;
      white-space: pre;
      color: var(--text-default-color);
    }
  }
}
